import { AlertTriangle } from "lucide-react";

const PRIORITY_RANK = { Urgent: 0, High: 1 };

export const rankOpenPositions = (rows) =>
  [...rows].sort((a, b) => (PRIORITY_RANK[a.priority] ?? 2) - (PRIORITY_RANK[b.priority] ?? 2) || b.days_open - a.days_open);

export const isEscalated = (priority) => priority in PRIORITY_RANK;

export const slug = (value) => String(value || "").toLowerCase().replaceAll(/[^a-z0-9]+/g, "-");

export const daysSince = (iso) => {
  if (!iso) return null;
  const then = new Date(iso);
  if (Number.isNaN(then.getTime())) return null;
  return Math.max(0, Math.floor((Date.now() - then.getTime()) / 86400000));
};

export const StatusPill = ({ status }) => (
  <span className={`ops-status is-${slug(status)}`} data-testid={`status-${slug(status)}`}>
    {status}
  </span>
);

export const PriorityPill = ({ priority }) =>
  isEscalated(priority) ? <span className={`ops-pill is-${priority === "Urgent" ? "red" : "amber"}`}>{priority}</span> : null;

export const ClientName = ({ name }) =>
  name && name !== "No client linked" ? (
    <span className="ops-cell-client">{name}</span>
  ) : (
    <span className="ops-cell-client is-unlinked" title="This record has no client linked yet">
      <AlertTriangle size={14} aria-hidden="true" /> No client linked
    </span>
  );

export const Age = ({ days, tone }) => (
  <span className={`ops-age ${tone ? `is-${tone}` : ""}`}>{days === null || days === undefined ? "—" : `${days} d`}</span>
);
